export default "__VITE_ASSET__f7147169__"